<div class="service-title service-title-bg">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container h-100 ml-0">
                <div class="row h-100">
                    <a routerLink="/products/mattress-ticking" class="col-md-3 position-relative text-center text-white h-100" style="background:url('assets/img/photo/8-sm.jpg') no-repeat 100% 100%">
                        <span class="position-absolute bottom-0 start-0 w-100 p-2 text-xl text-uppercase font-weight-100">
                            Mattress weaving ticking jacquard Fabric
                        </span>
                    </a>
                    <a routerLink="/products/stretch-fabrics" class="col-md-3 position-relative text-center text-white h-100" style="background:url('assets/img/photo/ST-2-sm.jpg') no-repeat 100% 100%">
                        <span class="position-absolute bottom-0 start-0 w-100 p-2 text-xl text-uppercase font-weight-100">
                            Mattress Knitting ticking jacquard Fabric
                        </span>
                    </a>
                    <a routerLink="/products/tarpaulin-fabric" class="col-md-3 position-relative text-center text-white h-100" style="background:url('assets/img/photo/202-sm.jpg') no-repeat 100% 100%">
                        <span class="position-absolute bottom-0 start-0 w-100 p-2 text-xl text-uppercase font-weight-100">
                            Tarpaulin fabrics
                        </span>
                    </a>
                    <a routerLink="/products/technical-fabric" class="col-md-3 position-relative text-center text-white h-100" style="background:url('assets/img/photo/technical-sm.jpg') no-repeat 100% 100%">
                        <span class="position-absolute bottom-0 start-0 w-100 p-2 text-xl text-uppercase font-weight-100">
                            Technical Fabric
                        </span>
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>

<section class="service-section pt-100 pb-70">
    <div class="container">
        <div class="section-head text-center">
            <h2>Our <span>Products</span></h2>
            <p>The HIKMATEX group manufactures 6 families of products :</p>
        </div>

        <div class="row">
            <div class="col-lg-4 col-md-6 col-sm-6" *ngFor="let produit of produits">
                <div class="service-card">
                    <img src="assets/img/produit/{{produit.src}}" class="w-25" alt="produit">
                    <h3 class="mt-2">{{produit.titre}}</h3>
                    <p>{{produit.description}}</p>
                    <div class="theme-button">
                        <a routerLink="/products/{{produit.url}}" class="default-btn">Read More</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
